<template>
  <div class="chooseStore" v-loading="loading">
    <login-header v-bind="headerInfo" @listenToChildEvent="showMsgFromChild"></login-header>
    <div class="wrap2">
      <div class="select-tit">请选择需要创建店铺的类型</div>
      <div class="shop-type">
        <ul>
          <li  v-for="(item,index) in storeType" :key="index">
            <div class="shop-type-box">
              <div :class="item.id ==  4 ? 'free' : '' "></div>
              <div class="shop-type-icon"><img :src="item.ico" alt="" class="shop-type-icon"></div>
              <div class="shop-type-name" v-text="item.name"></div>
              <div class="shop-type-tips" v-text="item.desc"></div>
              <span  class="shop-type-btn" @click="toCreateStore(index)" style="cursor: pointer">立即开店</span>
              <span class="shop-type-more">了解更多>></span>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <login-footer :description="desc"></login-footer>

  </div>
</template>

<script>

// 选择创建店铺的类型

import loginHeader from '../header'
import loginFooter from '../footer'
import shopmendian from '../../assets/img/shop-mendian.png'
import shopqiye from '../../assets/img/shop-qiye.png'
import dianshang from '../../assets/img/shop-dianshang.png'
import shopcanyin from '../../assets/img/shop-canyin.png'
import knowledge from '../../assets/img/knowledge.png'
import shopmeiye from '../../assets/img/shop-meiye.png'
import shoptongchengxinxi from '../../assets/img/shop-tongchengxinxi.png'
import shopjiudian from '../../assets/img/shop-jiudian.png'
import qs from 'qs'
export default {
  name: 'chooseStore',
  components: {
    loginHeader,
    loginFooter
  },
  data() {
    return {
      loading: false,
      headerInfo: {
        type: '选择店铺',
        userDisplayFlag: true,
        userName: '',
        logo: ''
      },
      desc: '',
      storeType: [ ]
    }
  },
  created() {
    document.title = localStorage.getItem('title')
    this.loginInfo = qs.parse(localStorage.getItem('xdata'))
    this.headerInfo.logo = this.loginInfo.logo
    this.desc = this.loginInfo.desc
  },
  mounted() {
    var mobile = localStorage.getItem('mobile')
    this.headerInfo.userName = mobile
    this.renderPage()
  },
  methods: {
    showMsgFromChild(data, loadingData) {
      var that = this
      that.loading = loadingData
      setTimeout(() => {
        that.loading = false
        that.headerInfo.userDisplayFlag = data
        localStorage.setItem('mobile', '')
        localStorage.setItem('mytoken', '')
        that.$router.push({ path: `/login.html` })
      }, 500)
    },
    renderPage() {
      var that = this
      var temp = []
      QM.apinew({
        url: '/seller/industry/types',
        method: 'get',
        success: function (xdata) {
          that.storeType = xdata.data
          for (var k in that.storeType) {
            temp.push(that.storeType[k])
          }
          for (var i = 0; i < temp.length; i++) {
            if (temp[i].domain_prefix === 'seller') {
              temp[i].ico = dianshang
            } else if (temp[i].domain_prefix === 'cy') {
              temp[i].ico = shopcanyin
            } else if (temp[i].domain_prefix === 'mei') {
              temp[i].ico = shopmeiye
            } else if (temp[i].domain_prefix === 'store') {
              temp[i].ico = shopmendian
            } else if (temp[i].domain_prefix === 'qy') {
              temp[i].ico = shopqiye
            } else if (temp[i].domain_prefix === 'city') {
              temp[i].ico = shoptongchengxinxi
            } else if (temp[i].domain_prefix === 'hotel') {
              temp[i].ico = shopjiudian
            } else if (temp[i].domain_prefix === 'reta') {
              temp[i].ico = knowledge
            }
          }
        },
        error: function (xdata) {
          that.$message.error(xdata.message)
        }
      })
    },
    toCreateStore(index) {
      var that = this
      that.loading = true
      this.$router.push({ path: `/createStore/${this.storeType[index].id}.html` })
      that.loading = false
    }
  }
}
</script>

<style scoped>
  .shop-type li{
    margin-bottom: 20px;
  }
</style>